var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_511_44455"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_511_44455)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 0,
    fill: "#FFFFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.5,
    cy: 26.5,
    rx: 2.5,
    ry: 2.5,
    fill: "#C00000",
    fillOpacity: 0.30000001192092896
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 44,
    width: 34,
    height: 3,
    rx: 1,
    fill: "#C00000",
    fillOpacity: 0.30000001192092896
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 32,
    width: 34,
    height: 15,
    rx: 1,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#19191A",
    fill: "none",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 39.5,
    x2: 45,
    y2: 39.5,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#19191A",
    fill: "none",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5,
    cy: 39.5,
    rx: 1.5,
    ry: 1.5,
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 39.5,
    rx: 1.5,
    ry: 1.5,
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.25,51L20.25,47L21.75,47L21.75,51L20.25,51Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.25,51L42.25,47L43.75,47L43.75,51L42.25,51Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.75,32L39.75,26L41.25,26L41.25,32L39.75,32Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.72272209841309,21.3009005Q43.72917509841309,21.8349317,44.38674349841308,22.768681L44.386866598413086,22.7685945Q44.43877509841309,22.8423049,44.50667569841308,22.9016109Q44.57457729841309,22.9609168,44.65460109841308,23.0024378Q44.73462489841309,23.0439587,44.82220939841309,23.0653281Q44.909793898413085,23.0866976,44.99994849841309,23.0866976Q45.073802898413085,23.0866976,45.14623639841309,23.0722895Q45.218671798413084,23.0578814,45.28690339841309,23.0296187Q45.355134998413085,23.0013559,45.41654209841309,22.960325Q45.477949098413085,22.9192939,45.530172298413085,22.8670716Q45.582393598413084,22.8148491,45.62342449841309,22.7534418Q45.66445539841308,22.6920347,45.692718498413086,22.6238027Q45.72098159841309,22.5555706,45.73538969841309,22.4831359Q45.749797798413084,22.4107013,45.74979879841308,22.3368475Q45.74979879841308,22.0993114,45.61303039841309,21.9051003L45.613153498413084,21.9050139Q44.74907209841309,20.67801732,43.425790298413084,19.975874174Q42.057784598413086,19.25000018,40.499998598413086,19.2500003Q38.94221449841309,19.25,37.57420869841309,19.975874035Q36.250928638413086,20.67801636,35.38684695841309,21.9050139L35.386969628413084,21.9051003Q35.25020146841309,22.0993114,35.25020146841309,22.3368475Q35.25020146841309,22.4107013,35.26460969841309,22.4831359Q35.27901780841309,22.5555706,35.307280418413086,22.6238024Q35.335543038413086,22.6920345,35.37657403841309,22.7534418Q35.41760497841309,22.8148489,35.46982746841309,22.8670714Q35.52204998841309,22.9192939,35.583457168413084,22.9603248Q35.644864318413084,23.0013556,35.713096318413086,23.0296185Q35.78132831841309,23.0578814,35.85376301841308,23.0722895Q35.92619771541309,23.0866976,36.000051498413086,23.0866976Q36.090205557413086,23.0866976,36.177790378413086,23.0653281Q36.26537519841309,23.0439587,36.345398788413085,23.0024381Q36.42542230841308,22.960917,36.493323508413084,22.9016111Q36.561224698413085,22.8423052,36.613133428413086,22.7685947L36.613256038413084,22.768681Q37.27082529841309,21.8349313,38.277277498413085,21.3009002Q39.31552199841309,20.75,40.499998598413086,20.7500003Q41.684477298413086,20.75000018,42.72272209841309,21.3009005Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.823133109375,15.7582492Q46.791701109375,16.7338006,48.157588109375,18.4641218L48.157706109375,18.4640288Q48.210348109375,18.530715,48.276575109375,18.5839334Q48.342802109375,18.6371517,48.419254109375004,18.674203900000002Q48.495708109375,18.711256,48.578514109375,18.7302642Q48.661320109375,18.7492719,48.746277109375,18.7492719Q48.820129109375,18.749271399999998,48.892563109375004,18.7348633Q48.964998109375,18.7204552,49.033230109375,18.6921926Q49.101463109375004,18.6639299,49.162868109375,18.622899099999998Q49.224277109374995,18.5818682,49.276501109375005,18.5296454Q49.328722109375,18.477422699999998,49.369753109375,18.4160156Q49.410782109375,18.3546085,49.439045109375,18.2863765Q49.467308109375,18.2181444,49.481716109375,18.14571Q49.496124109375,18.0732756,49.496126109375,17.9994218Q49.496126109375,17.8729746,49.454658109375,17.75352Q49.413193109375,17.634065200000002,49.334846109375,17.5348146L49.334965109375,17.5347214Q47.760040109375,15.5395874,45.489180109375,14.4142319Q43.139872109375,13.25000018,40.499964709375,13.25000048Q37.860062609375,13.25,35.510756009375,14.41423136Q33.239898619375,15.5395863,31.664974029375,17.5347199L31.665091689375,17.5348129Q31.586744959375,17.6340635,31.545278549375,17.7535181Q31.503812079375,17.872973,31.503812079375,17.9994202Q31.503812079375,18.0732737,31.518220309375,18.1457081Q31.532628419375,18.218143,31.560891029375,18.286375Q31.589153649375,18.3546071,31.630184649375,18.4160142Q31.671215589375,18.477421800000002,31.723438079375,18.529644Q31.775660599375,18.5818663,31.837067779375,18.6228971Q31.898474929375,18.663928,31.966706929375,18.6921906Q32.034938929375,18.7204533,32.107373629375,18.7348619Q32.179808326375,18.74927,32.253662109375,18.7492704Q32.338621243375,18.7492704,32.421426739375,18.7302623Q32.504232229375,18.711254099999998,32.580686029375,18.674202Q32.657139839375,18.6371498,32.723365839375,18.583931Q32.789591849375,18.5307131,32.842232589375,18.4640274L32.842350189375,18.4641204Q34.208236909375,16.7337985,36.176802109375004,15.7582486Q38.211350009374996,14.75,40.499964709375,14.75000048Q42.788584109375,14.75000024,44.823133109375,15.7582492Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.f406c34fda11de656012dd7c7cef248d.svg";
export { ForwardRef as ReactComponent };